import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

interface AccessRequestData {
  subject: string
  message: string
  email: string
  name: string
  company_name: string
}

interface AccessRequestResponse {
  message: string
}

const REQUEST_ACCESS_URL = "/request-access/"

export const requestAccessApi = createApi({
  reducerPath: "requestAccessApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_URL || "",
  }),
  endpoints: (builder) => ({
    sendAccessRequest: builder.mutation<
      AccessRequestResponse,
      AccessRequestData
    >({
      query: (data) => ({
        url: REQUEST_ACCESS_URL,
        method: "POST",
        body: data,
      }),
    }),
  }),
})

export const { useSendAccessRequestMutation } = requestAccessApi
